// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__4snku","ant-tooltip":"index_ant-tooltip__2Unax"};